import { render, staticRenderFns } from "./ExpiryReminderLog.vue?vue&type=template&id=69abd340&"
import script from "./ExpiryReminderLog.vue?vue&type=script&lang=js&"
export * from "./ExpiryReminderLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports